import React from 'react';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import GridContainer from '../../../components/UI/Grid/GridContainer';
import GridItem from '../../../components/UI/Grid/GridItem';
import Card from '../../../components/UI/Card/Card';
import CardBody from '../../../components/UI/Card/CardBody';
import CardHeader from '../../../components/UI/Card/CardHeader';
//img
import img07 from '../../../assets/img/img07.jpg';

import sectionIdentidadStyle from '../../../assets/jss/coscef/views/indexSections/sectionIdentidadStyle';

const useStyles = makeStyles(sectionIdentidadStyle);

const IndexIdentidad = () => {
  const classes = useStyles();

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            <div className={classes.section}>
              <GridContainer justify='center'>
                <GridItem xs={12} sm={8} md={8}>
                  <h2 className={classes.title}>
                    Nuestro lema es, enseñar a hacer.
                  </h2>
                  <h5 className={classes.description}>
                    Somos un equipo de consultores y tenedores de libros, con
                    elevadas competencias profesionales y alta experiencia.
                    Profesionales de las Ciencias Económicas, especializados en
                    temáticas empresariales y de cooperativas, con experiencia
                    en el escenario gerencial empresarial y cooperativo cubano.
                  </h5>
                </GridItem>
              </GridContainer>
            </div>
            <div className={classes.marginTop35}>
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  className={classes.mlAuto + ' ' + classes.mrAuto}
                >
                  <Card plain blog className={classes.card}>
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={6}
                        md={6}
                        className={classes.marginTop25}
                      >
                        <CardHeader image plain>
                          <a
                            href='#pablito'
                            onClick={(e) => e.preventDefault()}
                          >
                            <img src={img07} alt='...' />
                          </a>
                          <div
                            className={classes.coloredShadow}
                            style={{
                              backgroundImage: `url(${img07})`,
                              opacity: '1',
                            }}
                          />
                        </CardHeader>
                      </GridItem>
                      <GridItem xs={12} sm={6} md={6}>
                        <Card color='dark'>
                          <CardBody color>
                            <h3
                              className={
                                classes.cardTitleWhite +
                                ' ' +
                                classes.textCenter
                              }
                            >
                              Que ofrecemos...
                            </h3>
                            <br />
                            <p className={classes.cardDescriptionWhite}>
                              Ofrecemos servicios de Teneduría de libros, de
                              Consultoría y Coaching a empresas y cooperativa
                              cubanas, facilitándoles el mejoramiento de su
                              contabilidad y finanzas, así como el proceso de
                              mejora de la organización y el desarrollo de
                              competencias personales y profesionales hasta el
                              nivel optimo.
                            </p>
                          </CardBody>
                        </Card>
                      </GridItem>
                    </GridContainer>
                  </Card>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexIdentidad;
